import type { JSX } from 'react'

import { useUnit } from 'effector-react'
import { Fragment, memo } from 'react'
import { $isComponentsLoaded } from '../../model/components'
import { $viewComponents } from '../../model/view-components'
import { getComponent } from '../lib'
import { LoadMoreComponentsTrigger } from './load-more-components-trigger'

const INSERT_TRIGGER_N_ITEMS_BEFORE = 2

export const DynamicComponents = memo(DynamicComponents_)
function DynamicComponents_(): JSX.Element {
  const [rows, isLoaded] = useUnit([$viewComponents, $isComponentsLoaded])
  const triggerIndex = Math.max(rows.length - INSERT_TRIGGER_N_ITEMS_BEFORE, 0)

  return (
    <>
      {rows.map((row, i) => {
        const shouldInsertTrigger = !isLoaded && i === triggerIndex

        const { id, appearance } = row

        const Component = getComponent(appearance.contentType)

        return (
          <Fragment key={id}>
            {shouldInsertTrigger && <LoadMoreComponentsTrigger />}
            <Component id={id} index={i} />
          </Fragment>
        )
      })}
      {!isLoaded && rows.length === triggerIndex && (
        <LoadMoreComponentsTrigger />
      )}
    </>
  )
}
